import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Refresh = ({
  size,
  type,
  theme,
  className,
  dataTestId = "refresh-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2193 5.18353C11.885 5.33782 11.4889 5.1919 11.3346 4.8576L11.2112 4.59011C10.2918 2.59813 7.93164 1.72861 5.93966 2.648L5.76076 2.73056C4.1612 3.46883 3.28542 5.1361 3.47847 6.79576L4.29429 5.87497C4.53805 5.59984 4.95943 5.57506 5.23546 5.81964C5.51149 6.06421 5.53764 6.48551 5.29388 6.76065L3.3848 8.91537C3.26712 9.0482 3.1011 9.12837 2.92362 9.13808C2.74613 9.14779 2.57189 9.08624 2.43959 8.9671L0.2934 7.03428C0.0193578 6.78748 -0.0033775 6.36599 0.242619 6.09285C0.488616 5.81971 0.910191 5.79836 1.18423 6.04515L2.14973 6.91467C1.90815 4.70952 3.0768 2.50083 5.20202 1.51995L5.38091 1.43738C8.0415 0.209414 11.1938 1.37078 12.4218 4.03137L12.5452 4.29885C12.6995 4.63315 12.5536 5.02924 12.2193 5.18353ZM10.6878 9.22379C10.4431 9.49894 10.4679 9.92032 10.743 10.165C11.0182 10.4096 11.4396 10.3849 11.6842 10.1097L12.5125 9.17818C12.7077 10.8393 11.8318 12.509 10.2308 13.2479L10.0105 13.3496C8.0185 14.269 5.65837 13.3995 4.73899 11.4075L4.61553 11.14C4.46124 10.8057 4.06516 10.6598 3.73085 10.8141C3.39655 10.9684 3.25063 11.3644 3.40492 11.6987L3.52838 11.9662C4.75635 14.6268 7.90864 15.7882 10.5692 14.5602L10.7895 14.4585C12.9153 13.4774 14.084 11.2678 13.8416 9.0621L14.8125 9.93341C15.0865 10.1793 15.508 10.1565 15.7539 9.88252C15.9998 9.6085 15.9771 9.187 15.703 8.94109L13.5519 7.01056C13.4199 6.89211 13.2461 6.83114 13.0691 6.84112C12.892 6.8511 12.7262 6.93121 12.6084 7.06375L10.6878 9.22379Z"
    />
  </SVGIcon>
);
